import { Injectable, inject } from '@angular/core';

import { WidgetPage } from '@frontend/sports/types/components/widget';
import { NavigationRouterService } from '@frontend/sports/web/navigation-data-access';
import { WidgetLayoutHook } from '@frontend/sports/widget/feature/layout';

@Injectable({ providedIn: 'root' })
export class HomeNavigationHighlightService extends WidgetLayoutHook {
    private navigationRouter = inject(NavigationRouterService);

    constructor() {
        super(WidgetPage.HomeLobby);
    }

    onResolve(): void {
        this.navigationRouter.setNavigation('home');
    }

    onDestroy(): void {
        this.navigationRouter.resetNavigation();
    }
}
